import { Component, Input, OnInit } from '@angular/core';
import { AccessibilityChecksRepoService } from '@client/app/services/api/accessibility/accessibility-checks-repo/accessibility-checks-repo.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import {
    AccessibilityDialogsHelpCenterComponent,
} from '@client/app/modules/accessibility/dialogs/help-center/help-center.component';
import {
    AccessibilityDialogsNewHelpCenterComponent,
} from '@client/app/modules/accessibility/dialogs/new-help-center/new-help-center.component';

@Component({
    selector: 'acc-help-center-btn',
    standalone: false,
    template: `
        <button (click)="openHelpCenter()"
            role="button"
            [disabled]="loading"
            [attr.aria-label]="'Go to help center' | translate"
            class="btn btn-secondary">
            <span aria-hidden="true" [ngClass]="['GLOBAL', 'HELPCENTER'] | monIcons"></span>
        </button>
    `,
})
export class AccHelpCenterBtnComponent implements OnInit {
    @Input() check: any;

    loading: boolean = false;
    issue: any;

    constructor (
        private ng2AccessibilityChecksRepoService: AccessibilityChecksRepoService,
        private ng2MonEventsService: MonEventService,
    ) {}

    ngOnInit () {
        this.loading = false;
    }

    openHelpCenter () {
        this.loading = true;
        this.ng2AccessibilityChecksRepoService.getHelp(this.check.id)
            .then((data: any) => {
                if (data.article_url && typeof data.article_url === 'string') {
                    window.open(data.article_url, '_blank');
                } else if (data.suggestion === '') {
                    // New center
                    this.openNewCenter(this.check, data);
                } else {
                    // Old center
                    this.openOldCenter(this.check, data);
                }
                this.loading = false;
            }, () => {})
            .finally(() => {
                this.loading = false;
            });
    }

    private openOldCenter (check: any, data: any) {
        const params = {
            body: AccessibilityDialogsHelpCenterComponent,
            data: { check: check, data: data },
            size: 'lg',
        };

        this.ng2MonEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    private openNewCenter (check: any, data: any) {
        const params = {
            body: AccessibilityDialogsNewHelpCenterComponent,
            data: { check: check, data: data },
            size: 'lg',
        };

        this.ng2MonEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }
}
